import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=3861f730&scoped=true&"
import script from "./patient.vue?vue&type=script&lang=js&"
export * from "./patient.vue?vue&type=script&lang=js&"
import style0 from "./patient.vue?vue&type=style&index=0&id=3861f730&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861f730",
  null
  
)

export default component.exports